// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%273%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%2720 6 9 17 4 12%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/ForMarina.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-size: 1rem !important;
  /* font-family: "Poppins", serif !important; */
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.00938em;
  /* background-color: #fff; */
}
*, ::after, ::before {
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: #32aa27 !important;
}
.brand {
  display: flex;
  padding: 15px 0;
}
.brand a {
  display: flex;
}
.brand img {
  height: 50px;
}
.mob-brand {
  display: flex;
  justify-content: center;
}
.mob-brand img {
  height: 30px;
}
.mob-head-brand {
  display: none;
  align-items: center;
}
.mob-head-brand img {
  height: 28px;
  margin-left: 10px;
}
.carousel .slide {
  position: relative;
}
.carousel .slide div {
  height: 600px;
  background-size: cover;
  background-position: center;
}
.carousel .slide img {
  top: 50%;
  left: 50%;
  width: unset;
  height: 100%;
  position: absolute;
  transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}
nav button {
  position: relative;
  border: 2px solid transparent !important;
}
nav button.MuiButton-text:after {
  width: 0%;
  top: 100%;
  left: 50%;
  height: 2px;
  content: "";
  position: absolute;
  background: #32aa27;
  transform: translateX(-50%);
  transition: ease-out all 0.3s;
}
nav button.MuiButton-text:hover:after {
  width: 100%;
}
nav button.MuiButton-text:hover {
  color: #32aa27;
  background: transparent;
}
nav button.MuiButton-text:last-child {
  color: #32aa27 !important;
  margin-right: 0px !important;
  border-color: #32aa27 !important;
}
nav button.MuiButton-text:last-child:hover {
  color: #fff !important;
  background-color: #32aa27 !important;
}
nav button.MuiButton-text:last-child:after {
  content: unset;
}
.hero-section {
  padding: 40px 0px;
  display: flex;
  margin-top: 56px;
  position: relative;
  align-items: center;
  background-position: 50%;
}

.top-section {
  margin-top: 56px;
}
.inner.hero-section {
  height: 250px;
  background-size: cover;
}
.inner.hero-section:before {
  background: #00000080;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.inner .hero-overlay {
  width: 100%;
  position: relative;
}
.hero-overlay a {
  text-decoration: none;
}
.carousel-root > :nth-child(2) {
  display: none;
}
.carousel .carousel-status {
  display: none;
}
.carousel .control-dots .dot {
  width: 20px;
  height: 20px;
  box-shadow: none;
}
.btn-primary {
  color: #fff !important;
  background-color: #32aa27 !important;
}
.btn-contact {
  color: #32aa27 !important;
  border-color: #32aa27 !important;
}
.btn-contact:hover {
  color: #fff !important;
  background-color: #32aa27 !important;
}
.hero-content {
  color: #fff;
  padding: 3rem 1rem;
  text-align: center;
  text-decoration: none;
}
.inner .hero-content {
  /*top: 50%;
  left: 50%;
  width: 100%;
  padding: 0 20px;
  background: none;
  max-width: 1200px;
  text-align: center;
  position: absolute;
  transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);*/
}
.hero-content h1 {
  margin: 0;
  line-height: 1.5;
  font-size: 30px;
}
.hero-content h4 {
  font-size: 1rem;
  margin: 0 0 20px;
  font-weight: normal;
}
.hero-content button {
  /* z-index: 9999; */
  position: relative;
}
.title {
  margin-top: 0;
  line-height: 1.3;
  font-size: 1.5rem;
  margin-bottom: 10px;
}
.sub-title {
  color: #32aa27;
  margin: 0 0 10px 0;
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-transform: uppercase;
}
.blog-image {
  width: 100%;
  height: 180px;
  display: block;
  object-fit: cover;
}
.checkbox {
  align-items: flex-start !important;
}
.empowering h3 {
  display: flex;
  line-height: 1.3;
  font-size: 1.25rem;
  margin: 15px 0 5px;
  /* align-items: center;
  white-space: normal;
  justify-content: space-between; */
}
.checkbox > span {
  padding: 2px 8px;
}
.blog-thumb {
  height: 200px;
  margin-bottom: 10px;
  background-size: cover;
  background-position: center;
}
.blog-sub-description {
  margin: 10px 0px;
}
.contact-info {
  width: 100%;
  padding: 3rem;
  border-radius: 10px;
  background-color: #ebebeb;
}
.w-100 {
  width: 100%;
}
.contact-info h4 {
  margin-bottom: 10px;
}
.contact-item {
  gap: 10px;
  display: flex;
  align-items: center;
}
.footer {
  text-align: center;
  background-color: #162415;
}
.footer-link {
  gap: 20px;
  display: flex;
  flex-flow: wrap;
  padding: 20px 0;
  justify-content: center;
}
.footer-link a {
  color: #fff;
  text-decoration: underline;
}
@media only screen and (min-width: 768px) {
  .hero-section, .top-section {
    margin-top: 64px;
  }
  .inner.hero-section {
    min-height: 400px;
  }
  .hero-content {
    padding: 30px 0px;
    text-align: left;
  }
  .title {
    font-size: 2rem;
  }
  .hero-content h1 {
    font-size: 4.5rem;
  }
  .hero-content h4 {
    font-size: 1.5rem;
  }
}
@media only screen and (min-width: 992px) {
  .hero-section {
    margin-top: 80px;
  }
  .top-section {
    margin-top: 80px;
  }
  .inner .hero-content {
    padding: 0 0;
    text-align: left;
  }
  .hero-content h1 {
    font-size: 5rem;
  }
  .hero-content h4 {
    font-size: 2rem;
  }
}

.blog-list h3 {
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.blog-list span.date {
  color: #666;
  display: block;
  font-size: 14px;
  margin-bottom: 10px;
}
.blog-list .btn-primary {
  margin-top: 20px;
}
.page-head {
  position: relative;
}
.page-head:before {
  top: 50%;
  left: 50%;
  color: #fff;
  width: 100%;
  font-size: 5rem;
  content: "Blog";
  font-weight: bold;
  position: absolute;
  padding: 10px 40px;
  text-align: center;
  text-transform: uppercase;
  background: rgba(0, 0, 0, 0.5);
  transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}

.blog-title {
  /* overflow: hidden;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis; */
}

.serviceCard:hover {
  color: #2e8b57;
  cursor: pointer;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.blog-card {
  display: flex;
  height: 100%;
}
.mobile-section {
  display: none;
}
.title-section {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
}

/* Show/Hide Classes for FAQ section */
.showFaq {
  display: block;
}
.hideFaq {
  display: none;
}

@media only screen and (max-width: 991px) {
  .brand img {
    height: 30px !important;
  }
}
@media only screen and (max-width: 767px) {
  .blog-image {
    width: 100%;
    height: 220px;
    object-fit: cover;
  }
  .title, .sub-title, .section-content {
    text-align: center;
  }
  .mobile-section {
    display: block;
  }
  .desktop-section {
    display: none;
  }
  .title-section {
    display: block;
  }
  .title-section .title {
    margin-bottom: 15px !important;
  }
  .title-section .language-dropdown {
    margin: 0 auto;
  }
}
.service-fees-section {
  background-color: #ebebeb;
}
.service-fees-body {
  color: #555;
  line-height: 1.7;
  margin: 0 0 12px 0;
}
.service-fees-list {
  list-style: none;
  padding: 0;
  margin: 20px 0 24px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.service-fees-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.95rem;
  color: #333;
  font-weight: 500;
}
.service-fees-list li::before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  min-width: 20px;
  background-color: #32aa27;
  border-radius: 50%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 12px;
  background-repeat: no-repeat;
  background-position: center;
}
.service-fees-callout {
  background-color: #f0faf0;
  border-left: 4px solid #32aa27;
  padding: 16px 20px;
  border-radius: 0 8px 8px 0;
  margin-top: 8px;
}
.service-fees-callout p {
  margin: 0 0 4px 0;
  color: #333;
  line-height: 1.6;
}
.service-fees-callout p:last-child {
  margin-bottom: 0;
}
.service-fees-partners-card {
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 32px;
  height: 100%;
  box-sizing: border-box;
}
.service-fees-subheading {
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0 0 16px 0;
  line-height: 1.4;
  color: #222;
}
.service-fees-divider {
  border: none;
  border-top: 1px solid #ddd;
  margin: 20px 0;
}
.service-fees-goal {
  font-style: italic;
  color: #555;
  line-height: 1.7;
  margin: 0;
  font-size: 0.95rem;
}

/* ============================================
   FOR MARINAS SECTION STYLES
   ============================================ */

.for-marinas-section {
  background-color: #f5f7f5;
  position: relative;
  overflow: hidden;
}

.for-marinas-section .MuiContainer-root {
  position: relative;
  z-index: 2;
}

.for-marinas-content {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 36px 0;
  padding-right: 32%;
}

.for-marinas-left {
  flex: 0 0 auto;
  max-width: 300px;
}

.for-marinas-label {
  color: #32aa27;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  display: block;
  margin-bottom: 8px;
}

.for-marinas-headline {
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
  color: #1a1a1a;
}

.for-marinas-separator {
  width: 1px;
  background-color: #ccc;
  align-self: stretch;
  margin: 0 8px;
}

.for-marinas-middle {
  flex: 1 1;
  max-width: 380px;
}

.for-marinas-description {
  font-size: 0.8rem;
  line-height: 1.6;
  color: #666;
  margin: 0;
}

.for-marinas-right {
  flex: 0 0 auto;
}

.btn-add-marina {
  background-color: #32aa27 !important;
  color: #fff !important;
  padding: 10px 22px !important;
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  border-radius: 6px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
  white-space: nowrap !important;
}

.btn-add-marina:hover {
  background-color: #2a9020 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(50, 170, 39, 0.4);
}

.for-marinas-image {
  position: absolute;
  top: 0;
  right: 0;
  width: 32%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  z-index: 1;
  clip-path: polygon(15% 0, 100% 0, 100% 100%, 0% 100%);
}

/* Responsive styles for For Marinas section */

/* Large desktops */
@media only screen and (max-width: 1400px) {
  .for-marinas-content {
    gap: 28px;
  }

  .for-marinas-left {
    max-width: 280px;
  }

  .for-marinas-middle {
    max-width: 340px;
  }
}

/* Medium desktops */
@media only screen and (max-width: 1200px) {
  .for-marinas-content {
    gap: 20px;
    padding-right: 26%;
  }

  .for-marinas-headline {
    font-size: 1.35rem;
  }

  .for-marinas-left {
    max-width: 250px;
  }

  .for-marinas-middle {
    max-width: 280px;
  }

  .for-marinas-description {
    font-size: 0.85rem;
  }

  .for-marinas-image {
    width: 24%;
  }

  .btn-add-marina {
    padding: 10px 20px !important;
    font-size: 0.8rem !important;
  }
}

/* Tablets landscape */
@media only screen and (max-width: 1024px) {
  .for-marinas-content {
    gap: 16px;
    padding-right: 24%;
  }

  .for-marinas-headline {
    font-size: 1.25rem;
  }

  .for-marinas-left {
    max-width: 220px;
  }

  .for-marinas-middle {
    max-width: 240px;
  }

  .for-marinas-description {
    font-size: 0.8rem;
  }

  .for-marinas-image {
    width: 22%;
  }
}

/* Tablets portrait */
@media only screen and (max-width: 900px) {
  .for-marinas-section {
    background-color: #f5f7f5;
  }

  .for-marinas-content {
    flex-direction: column;
    text-align: center;
    padding: 40px 24px;
    gap: 16px;
  }

  .for-marinas-separator {
    display: none;
  }

  .for-marinas-left,
  .for-marinas-middle {
    max-width: 100%;
  }

  .for-marinas-headline {
    font-size: 1.4rem;
  }

  .for-marinas-headline br {
    display: none;
  }

  .for-marinas-description {
    font-size: 0.9rem;
    max-width: 500px;
    margin: 0 auto;
  }

  .for-marinas-image {
    display: none;
  }

  .btn-add-marina {
    padding: 12px 28px !important;
    font-size: 0.9rem !important;
  }
}

/* Large phones */
@media only screen and (max-width: 600px) {
  .for-marinas-content {
    padding: 36px 20px;
    gap: 14px;
  }

  .for-marinas-label {
    font-size: 0.7rem;
  }

  .for-marinas-headline {
    font-size: 1.3rem;
  }

  .for-marinas-description {
    font-size: 0.85rem;
  }
}

/* Small phones */
@media only screen and (max-width: 480px) {
  .for-marinas-content {
    padding: 32px 16px;
    gap: 12px;
  }

  .for-marinas-label {
    font-size: 0.65rem;
    margin-bottom: 8px;
  }

  .for-marinas-headline {
    font-size: 1.2rem;
  }

  .for-marinas-description {
    font-size: 0.8rem;
    line-height: 1.55;
  }

  .btn-add-marina {
    padding: 10px 24px !important;
    font-size: 0.85rem !important;
    width: 100%;
    max-width: 250px;
  }
}

/* Extra small phones */
@media only screen and (max-width: 360px) {
  .for-marinas-content {
    padding: 28px 12px;
  }

  .for-marinas-headline {
    font-size: 1.1rem;
  }

  .for-marinas-description {
    font-size: 0.75rem;
  }

  .btn-add-marina {
    padding: 10px 20px !important;
    font-size: 0.8rem !important;
  }
}

/* ============================================
   NEW HERO SECTION STYLES
   ============================================ */

.new-hero-section {
  min-height: 85vh;
  display: flex;
  align-items: center;
  background-size: cover;
  background-position: center right;
  background-repeat: no-repeat;
  position: relative;
  margin-top: 0;
  padding-top: 80px;
}

.new-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(0, 0, 0, 0.5) 30%,
    rgba(0, 0, 0, 0.25) 60%,
    rgba(0, 0, 0, 0.05) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 0;
}

.new-hero-content {
  color: #fff;
  padding: 40px 0;
  padding-top: 100px;
}

/* Green Badge */
.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(50, 170, 39, 0.4);
  border: 1px solid rgba(50, 170, 39, 0.6);
  color: #fff;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 24px;
  text-transform: uppercase;
}

.hero-badge .badge-icon {
  font-size: 1rem;
}

/* Headlines */
.hero-headline {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.1;
  margin: 0 0 8px 0;
  color: #fff;
}

.hero-headline .dot,
.hero-subheadline .dot {
  display: inline-block;
  width: 0.18em;
  height: 0.18em;
  background-color: #fff;
  border-radius: 50%;
  vertical-align: baseline;
  margin: 0 0.15em 0 0.05em;
}

.hero-subheadline {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.1;
  margin: 0 0 24px 0;
  color: #fff;
}

.hero-description {
  font-size: 1.25rem;
  line-height: 1.6;
  margin: 0 0 32px 0;
  color: rgba(255, 255, 255, 0.9);
  max-width: 500px;
}

/* CTA Buttons */
.hero-buttons {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.btn-find-berth {
  background-color: #32aa27 !important;
  color: #fff !important;
  padding: 14px 32px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  border-radius: 6px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
}

.btn-find-berth:hover {
  background-color: #2a9020 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(50, 170, 39, 0.4);
}

.btn-list-berth {
  background-color: transparent !important;
  color: #fff !important;
  padding: 14px 32px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  border: 2px solid #fff !important;
  border-radius: 6px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
}

.btn-list-berth:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-2px);
}

.btn-list-berth .circled-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 2px solid #fff;
  border-radius: 50%;
  margin-right: 4px;
}

.btn-list-berth .circled-icon svg {
  font-size: 16px;
}

/* Feature Icons */
.hero-features {
  display: flex;
  gap: 48px;
  margin-top: 32px;
  flex-wrap: wrap;
}

.hero-feature {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #fff;
}

.hero-feature .feature-icon {
  font-size: 2.5rem;
  color: #32aa27;
}

.feature-text {
  display: flex;
  flex-direction: column;
}

.feature-title {
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
}

.feature-subtitle {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.7);
}

/* ============================================
   RESPONSIVE STYLES FOR NEW HERO
   ============================================ */

@media only screen and (max-width: 1200px) {
  .hero-headline,
  .hero-subheadline {
    font-size: 3rem;
  }
}

@media only screen and (max-width: 992px) {
  .new-hero-section {
    min-height: auto;
    padding-top: 80px;
  }

  .new-hero-overlay {
    position: relative;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0.5) 50%,
      rgba(0, 0, 0, 0.3) 100%
    );
  }

  .new-hero-content {
    padding-top: 40px;
  }

  .hero-headline,
  .hero-subheadline {
    font-size: 2.5rem;
  }

  .hero-description {
    font-size: 1.1rem;
    max-width: 100%;
  }

  .hero-features {
    gap: 32px;
    justify-content: flex-start;
  }
}

@media only screen and (max-width: 768px) {
  .new-hero-section {
    background-position: center;
    min-height: auto;
    padding-bottom: 20px;
  }

  .new-hero-overlay {
    position: relative;
    padding: 40px 0;
  }

  .new-hero-content {
    text-align: center;
    padding: 20px 0;
    padding-top: 30px;
  }

  .hero-badge {
    font-size: 0.7rem;
    padding: 8px 14px;
    margin-bottom: 20px;
  }

  .hero-headline,
  .hero-subheadline {
    font-size: 1.8rem;
  }

  .hero-description {
    font-size: 1rem;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  }

  .hero-buttons {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .btn-find-berth,
  .btn-list-berth {
    width: 100% !important;
    max-width: 300px !important;
    justify-content: center !important;
    padding: 12px 24px !important;
    font-size: 0.9rem !important;
  }

  .btn-list-berth .circled-icon {
    width: 20px;
    height: 20px;
  }

  .btn-list-berth .circled-icon svg {
    font-size: 14px;
  }

  .hero-features {
    justify-content: center;
    gap: 20px;
    margin-top: 30px;
    padding: 0 10px;
  }

  .hero-feature {
    flex-direction: column;
    text-align: center;
    min-width: 90px;
    flex: 1 1;
  }

  .feature-text {
    align-items: center;
  }

  .hero-feature .feature-icon {
    font-size: 1.8rem;
  }

  .feature-title {
    font-size: 0.8rem;
  }

  .feature-subtitle {
    font-size: 0.75rem;
  }
}

@media only screen and (max-width: 480px) {
  .new-hero-section {
    padding-top: 70px;
  }

  .new-hero-content {
    padding-top: 20px;
  }

  .hero-headline,
  .hero-subheadline {
    font-size: 1.5rem;
  }

  .hero-badge {
    font-size: 0.6rem;
    padding: 6px 10px;
    gap: 5px;
  }

  .hero-badge .badge-icon {
    font-size: 0.75rem;
  }

  .hero-description {
    font-size: 0.9rem;
    margin-bottom: 24px;
  }

  .btn-find-berth,
  .btn-list-berth {
    padding: 10px 20px !important;
    font-size: 0.85rem !important;
  }

  .hero-features {
    gap: 12px;
    margin-top: 24px;
  }

  .hero-feature {
    min-width: 70px;
  }

  .hero-feature .feature-icon {
    font-size: 1.5rem;
  }

  .feature-title {
    font-size: 0.7rem;
  }

  .feature-subtitle {
    font-size: 0.65rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/general/dockingmate/DockingMate.css"],"names":[],"mappings":"AACA;EACE,0BAA0B;EAC1B,8CAA8C;EAC9C,oDAAoD;EACpD,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,oCAAoC;EACpC,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,SAAS;EACT,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;;;;;;;;;;;;4CAY0C;AAC5C;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB;;mCAEiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;EAChC,mCAAmC;EACnC,oCAAoC;EACpC,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE;;;4BAG0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4EAA4E;AAC9E;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yDAAwP;EACxP,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,yDAAuD;EACvD,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;EACV,qDAAqD;AACvD;;AAEA,8CAA8C;;AAE9C,mBAAmB;AACnB;EACE;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;EACD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;iDAEiD;;AAEjD;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB;;;;;KAKC;EACH;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,SAAO;EACT;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\nbody {\n  font-size: 1rem !important;\n  /* font-family: \"Poppins\", serif !important; */\n  font-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: 0.00938em;\n  /* background-color: #fff; */\n}\n*, ::after, ::before {\n  box-sizing: border-box;\n}\na {\n  text-decoration: none;\n  color: #32aa27 !important;\n}\n.brand {\n  display: flex;\n  padding: 15px 0;\n}\n.brand a {\n  display: flex;\n}\n.brand img {\n  height: 50px;\n}\n.mob-brand {\n  display: flex;\n  justify-content: center;\n}\n.mob-brand img {\n  height: 30px;\n}\n.mob-head-brand {\n  display: none;\n  align-items: center;\n}\n.mob-head-brand img {\n  height: 28px;\n  margin-left: 10px;\n}\n.carousel .slide {\n  position: relative;\n}\n.carousel .slide div {\n  height: 600px;\n  background-size: cover;\n  background-position: center;\n}\n.carousel .slide img {\n  top: 50%;\n  left: 50%;\n  width: unset;\n  height: 100%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n}\nnav button {\n  position: relative;\n  border: 2px solid transparent !important;\n}\nnav button.MuiButton-text:after {\n  width: 0%;\n  top: 100%;\n  left: 50%;\n  height: 2px;\n  content: \"\";\n  position: absolute;\n  background: #32aa27;\n  transform: translateX(-50%);\n  transition: ease-out all 0.3s;\n}\nnav button.MuiButton-text:hover:after {\n  width: 100%;\n}\nnav button.MuiButton-text:hover {\n  color: #32aa27;\n  background: transparent;\n}\nnav button.MuiButton-text:last-child {\n  color: #32aa27 !important;\n  margin-right: 0px !important;\n  border-color: #32aa27 !important;\n}\nnav button.MuiButton-text:last-child:hover {\n  color: #fff !important;\n  background-color: #32aa27 !important;\n}\nnav button.MuiButton-text:last-child:after {\n  content: unset;\n}\n.hero-section {\n  padding: 40px 0px;\n  display: flex;\n  margin-top: 56px;\n  position: relative;\n  align-items: center;\n  background-position: 50%;\n}\n\n.top-section {\n  margin-top: 56px;\n}\n.inner.hero-section {\n  height: 250px;\n  background-size: cover;\n}\n.inner.hero-section:before {\n  background: #00000080;\n  content: \"\";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.inner .hero-overlay {\n  width: 100%;\n  position: relative;\n}\n.hero-overlay a {\n  text-decoration: none;\n}\n.carousel-root > :nth-child(2) {\n  display: none;\n}\n.carousel .carousel-status {\n  display: none;\n}\n.carousel .control-dots .dot {\n  width: 20px;\n  height: 20px;\n  box-shadow: none;\n}\n.btn-primary {\n  color: #fff !important;\n  background-color: #32aa27 !important;\n}\n.btn-contact {\n  color: #32aa27 !important;\n  border-color: #32aa27 !important;\n}\n.btn-contact:hover {\n  color: #fff !important;\n  background-color: #32aa27 !important;\n}\n.hero-content {\n  color: #fff;\n  padding: 3rem 1rem;\n  text-align: center;\n  text-decoration: none;\n}\n.inner .hero-content {\n  /*top: 50%;\n  left: 50%;\n  width: 100%;\n  padding: 0 20px;\n  background: none;\n  max-width: 1200px;\n  text-align: center;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);*/\n}\n.hero-content h1 {\n  margin: 0;\n  line-height: 1.5;\n  font-size: 30px;\n}\n.hero-content h4 {\n  font-size: 1rem;\n  margin: 0 0 20px;\n  font-weight: normal;\n}\n.hero-content button {\n  /* z-index: 9999; */\n  position: relative;\n}\n.title {\n  margin-top: 0;\n  line-height: 1.3;\n  font-size: 1.5rem;\n  margin-bottom: 10px;\n}\n.sub-title {\n  color: #32aa27;\n  margin: 0 0 10px 0;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  text-transform: uppercase;\n}\n.blog-image {\n  width: 100%;\n  height: 180px;\n  display: block;\n  object-fit: cover;\n}\n.checkbox {\n  align-items: flex-start !important;\n}\n.empowering h3 {\n  display: flex;\n  line-height: 1.3;\n  font-size: 1.25rem;\n  margin: 15px 0 5px;\n  /* align-items: center;\n  white-space: normal;\n  justify-content: space-between; */\n}\n.checkbox > span {\n  padding: 2px 8px;\n}\n.blog-thumb {\n  height: 200px;\n  margin-bottom: 10px;\n  background-size: cover;\n  background-position: center;\n}\n.blog-sub-description {\n  margin: 10px 0px;\n}\n.contact-info {\n  width: 100%;\n  padding: 3rem;\n  border-radius: 10px;\n  background-color: #ebebeb;\n}\n.w-100 {\n  width: 100%;\n}\n.contact-info h4 {\n  margin-bottom: 10px;\n}\n.contact-item {\n  gap: 10px;\n  display: flex;\n  align-items: center;\n}\n.footer {\n  text-align: center;\n  background-color: #162415;\n}\n.footer-link {\n  gap: 20px;\n  display: flex;\n  flex-flow: wrap;\n  padding: 20px 0;\n  justify-content: center;\n}\n.footer-link a {\n  color: #fff;\n  text-decoration: underline;\n}\n@media only screen and (min-width: 768px) {\n  .hero-section, .top-section {\n    margin-top: 64px;\n  }\n  .inner.hero-section {\n    min-height: 400px;\n  }\n  .hero-content {\n    padding: 30px 0px;\n    text-align: left;\n  }\n  .title {\n    font-size: 2rem;\n  }\n  .hero-content h1 {\n    font-size: 4.5rem;\n  }\n  .hero-content h4 {\n    font-size: 1.5rem;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .hero-section {\n    margin-top: 80px;\n  }\n  .top-section {\n    margin-top: 80px;\n  }\n  .inner .hero-content {\n    padding: 0 0;\n    text-align: left;\n  }\n  .hero-content h1 {\n    font-size: 5rem;\n  }\n  .hero-content h4 {\n    font-size: 2rem;\n  }\n}\n\n.blog-list h3 {\n  margin: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.blog-list span.date {\n  color: #666;\n  display: block;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n.blog-list .btn-primary {\n  margin-top: 20px;\n}\n.page-head {\n  position: relative;\n}\n.page-head:before {\n  top: 50%;\n  left: 50%;\n  color: #fff;\n  width: 100%;\n  font-size: 5rem;\n  content: \"Blog\";\n  font-weight: bold;\n  position: absolute;\n  padding: 10px 40px;\n  text-align: center;\n  text-transform: uppercase;\n  background: rgba(0, 0, 0, 0.5);\n  transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n}\n\n.blog-title {\n  /* overflow: hidden;\n  margin: 0;\n  white-space: nowrap;\n  text-overflow: ellipsis; */\n}\n\n.serviceCard:hover {\n  color: #2e8b57;\n  cursor: pointer;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n.blog-card {\n  display: flex;\n  height: 100%;\n}\n.mobile-section {\n  display: none;\n}\n.title-section {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 20px;\n}\n\n/* Show/Hide Classes for FAQ section */\n.showFaq {\n  display: block;\n}\n.hideFaq {\n  display: none;\n}\n\n@media only screen and (max-width: 991px) {\n  .brand img {\n    height: 30px !important;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .blog-image {\n    width: 100%;\n    height: 220px;\n    object-fit: cover;\n  }\n  .title, .sub-title, .section-content {\n    text-align: center;\n  }\n  .mobile-section {\n    display: block;\n  }\n  .desktop-section {\n    display: none;\n  }\n  .title-section {\n    display: block;\n  }\n  .title-section .title {\n    margin-bottom: 15px !important;\n  }\n  .title-section .language-dropdown {\n    margin: 0 auto;\n  }\n}\n.service-fees-section {\n  background-color: #ebebeb;\n}\n.service-fees-body {\n  color: #555;\n  line-height: 1.7;\n  margin: 0 0 12px 0;\n}\n.service-fees-list {\n  list-style: none;\n  padding: 0;\n  margin: 20px 0 24px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.service-fees-list li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.95rem;\n  color: #333;\n  font-weight: 500;\n}\n.service-fees-list li::before {\n  content: \"\";\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  background-color: #32aa27;\n  border-radius: 50%;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E\");\n  background-size: 12px;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.service-fees-callout {\n  background-color: #f0faf0;\n  border-left: 4px solid #32aa27;\n  padding: 16px 20px;\n  border-radius: 0 8px 8px 0;\n  margin-top: 8px;\n}\n.service-fees-callout p {\n  margin: 0 0 4px 0;\n  color: #333;\n  line-height: 1.6;\n}\n.service-fees-callout p:last-child {\n  margin-bottom: 0;\n}\n.service-fees-partners-card {\n  background-color: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n  padding: 32px;\n  height: 100%;\n  box-sizing: border-box;\n}\n.service-fees-subheading {\n  font-size: 1.15rem;\n  font-weight: 700;\n  margin: 0 0 16px 0;\n  line-height: 1.4;\n  color: #222;\n}\n.service-fees-divider {\n  border: none;\n  border-top: 1px solid #ddd;\n  margin: 20px 0;\n}\n.service-fees-goal {\n  font-style: italic;\n  color: #555;\n  line-height: 1.7;\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n/* ============================================\n   FOR MARINAS SECTION STYLES\n   ============================================ */\n\n.for-marinas-section {\n  background-color: #f5f7f5;\n  position: relative;\n  overflow: hidden;\n}\n\n.for-marinas-section .MuiContainer-root {\n  position: relative;\n  z-index: 2;\n}\n\n.for-marinas-content {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  padding: 36px 0;\n  padding-right: 32%;\n}\n\n.for-marinas-left {\n  flex: 0 0 auto;\n  max-width: 300px;\n}\n\n.for-marinas-label {\n  color: #32aa27;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.for-marinas-headline {\n  font-size: 1.35rem;\n  font-weight: 600;\n  line-height: 1.3;\n  margin: 0;\n  color: #1a1a1a;\n}\n\n.for-marinas-separator {\n  width: 1px;\n  background-color: #ccc;\n  align-self: stretch;\n  margin: 0 8px;\n}\n\n.for-marinas-middle {\n  flex: 1;\n  max-width: 380px;\n}\n\n.for-marinas-description {\n  font-size: 0.8rem;\n  line-height: 1.6;\n  color: #666;\n  margin: 0;\n}\n\n.for-marinas-right {\n  flex: 0 0 auto;\n}\n\n.btn-add-marina {\n  background-color: #32aa27 !important;\n  color: #fff !important;\n  padding: 10px 22px !important;\n  font-size: 0.8rem !important;\n  font-weight: 600 !important;\n  border-radius: 6px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.5px !important;\n  transition: all 0.3s ease !important;\n  white-space: nowrap !important;\n}\n\n.btn-add-marina:hover {\n  background-color: #2a9020 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(50, 170, 39, 0.4);\n}\n\n.for-marinas-image {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 32%;\n  height: 100%;\n  background-image: url('../../../assets/ForMarina.webp');\n  background-size: cover;\n  background-position: center;\n  z-index: 1;\n  clip-path: polygon(15% 0, 100% 0, 100% 100%, 0% 100%);\n}\n\n/* Responsive styles for For Marinas section */\n\n/* Large desktops */\n@media only screen and (max-width: 1400px) {\n  .for-marinas-content {\n    gap: 28px;\n  }\n\n  .for-marinas-left {\n    max-width: 280px;\n  }\n\n  .for-marinas-middle {\n    max-width: 340px;\n  }\n}\n\n/* Medium desktops */\n@media only screen and (max-width: 1200px) {\n  .for-marinas-content {\n    gap: 20px;\n    padding-right: 26%;\n  }\n\n  .for-marinas-headline {\n    font-size: 1.35rem;\n  }\n\n  .for-marinas-left {\n    max-width: 250px;\n  }\n\n  .for-marinas-middle {\n    max-width: 280px;\n  }\n\n  .for-marinas-description {\n    font-size: 0.85rem;\n  }\n\n  .for-marinas-image {\n    width: 24%;\n  }\n\n  .btn-add-marina {\n    padding: 10px 20px !important;\n    font-size: 0.8rem !important;\n  }\n}\n\n/* Tablets landscape */\n@media only screen and (max-width: 1024px) {\n  .for-marinas-content {\n    gap: 16px;\n    padding-right: 24%;\n  }\n\n  .for-marinas-headline {\n    font-size: 1.25rem;\n  }\n\n  .for-marinas-left {\n    max-width: 220px;\n  }\n\n  .for-marinas-middle {\n    max-width: 240px;\n  }\n\n  .for-marinas-description {\n    font-size: 0.8rem;\n  }\n\n  .for-marinas-image {\n    width: 22%;\n  }\n}\n\n/* Tablets portrait */\n@media only screen and (max-width: 900px) {\n  .for-marinas-section {\n    background-color: #f5f7f5;\n  }\n\n  .for-marinas-content {\n    flex-direction: column;\n    text-align: center;\n    padding: 40px 24px;\n    gap: 16px;\n  }\n\n  .for-marinas-separator {\n    display: none;\n  }\n\n  .for-marinas-left,\n  .for-marinas-middle {\n    max-width: 100%;\n  }\n\n  .for-marinas-headline {\n    font-size: 1.4rem;\n  }\n\n  .for-marinas-headline br {\n    display: none;\n  }\n\n  .for-marinas-description {\n    font-size: 0.9rem;\n    max-width: 500px;\n    margin: 0 auto;\n  }\n\n  .for-marinas-image {\n    display: none;\n  }\n\n  .btn-add-marina {\n    padding: 12px 28px !important;\n    font-size: 0.9rem !important;\n  }\n}\n\n/* Large phones */\n@media only screen and (max-width: 600px) {\n  .for-marinas-content {\n    padding: 36px 20px;\n    gap: 14px;\n  }\n\n  .for-marinas-label {\n    font-size: 0.7rem;\n  }\n\n  .for-marinas-headline {\n    font-size: 1.3rem;\n  }\n\n  .for-marinas-description {\n    font-size: 0.85rem;\n  }\n}\n\n/* Small phones */\n@media only screen and (max-width: 480px) {\n  .for-marinas-content {\n    padding: 32px 16px;\n    gap: 12px;\n  }\n\n  .for-marinas-label {\n    font-size: 0.65rem;\n    margin-bottom: 8px;\n  }\n\n  .for-marinas-headline {\n    font-size: 1.2rem;\n  }\n\n  .for-marinas-description {\n    font-size: 0.8rem;\n    line-height: 1.55;\n  }\n\n  .btn-add-marina {\n    padding: 10px 24px !important;\n    font-size: 0.85rem !important;\n    width: 100%;\n    max-width: 250px;\n  }\n}\n\n/* Extra small phones */\n@media only screen and (max-width: 360px) {\n  .for-marinas-content {\n    padding: 28px 12px;\n  }\n\n  .for-marinas-headline {\n    font-size: 1.1rem;\n  }\n\n  .for-marinas-description {\n    font-size: 0.75rem;\n  }\n\n  .btn-add-marina {\n    padding: 10px 20px !important;\n    font-size: 0.8rem !important;\n  }\n}\n\n/* ============================================\n   NEW HERO SECTION STYLES\n   ============================================ */\n\n.new-hero-section {\n  min-height: 85vh;\n  display: flex;\n  align-items: center;\n  background-size: cover;\n  background-position: center right;\n  background-repeat: no-repeat;\n  position: relative;\n  margin-top: 0;\n  padding-top: 80px;\n}\n\n.new-hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    to right,\n    rgba(0, 0, 0, 0.65) 0%,\n    rgba(0, 0, 0, 0.5) 30%,\n    rgba(0, 0, 0, 0.25) 60%,\n    rgba(0, 0, 0, 0.05) 100%\n  );\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 60px 0;\n}\n\n.new-hero-content {\n  color: #fff;\n  padding: 40px 0;\n  padding-top: 100px;\n}\n\n/* Green Badge */\n.hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background-color: rgba(50, 170, 39, 0.4);\n  border: 1px solid rgba(50, 170, 39, 0.6);\n  color: #fff;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  margin-bottom: 24px;\n  text-transform: uppercase;\n}\n\n.hero-badge .badge-icon {\n  font-size: 1rem;\n}\n\n/* Headlines */\n.hero-headline {\n  font-size: 3.5rem;\n  font-weight: 700;\n  line-height: 1.1;\n  margin: 0 0 8px 0;\n  color: #fff;\n}\n\n.hero-headline .dot,\n.hero-subheadline .dot {\n  display: inline-block;\n  width: 0.18em;\n  height: 0.18em;\n  background-color: #fff;\n  border-radius: 50%;\n  vertical-align: baseline;\n  margin: 0 0.15em 0 0.05em;\n}\n\n.hero-subheadline {\n  font-size: 3.5rem;\n  font-weight: 700;\n  line-height: 1.1;\n  margin: 0 0 24px 0;\n  color: #fff;\n}\n\n.hero-description {\n  font-size: 1.25rem;\n  line-height: 1.6;\n  margin: 0 0 32px 0;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 500px;\n}\n\n/* CTA Buttons */\n.hero-buttons {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.btn-find-berth {\n  background-color: #32aa27 !important;\n  color: #fff !important;\n  padding: 14px 32px !important;\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  border-radius: 6px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.5px !important;\n  transition: all 0.3s ease !important;\n}\n\n.btn-find-berth:hover {\n  background-color: #2a9020 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(50, 170, 39, 0.4);\n}\n\n.btn-list-berth {\n  background-color: transparent !important;\n  color: #fff !important;\n  padding: 14px 32px !important;\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  border: 2px solid #fff !important;\n  border-radius: 6px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.5px !important;\n  transition: all 0.3s ease !important;\n}\n\n.btn-list-berth:hover {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  transform: translateY(-2px);\n}\n\n.btn-list-berth .circled-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  margin-right: 4px;\n}\n\n.btn-list-berth .circled-icon svg {\n  font-size: 16px;\n}\n\n/* Feature Icons */\n.hero-features {\n  display: flex;\n  gap: 48px;\n  margin-top: 32px;\n  flex-wrap: wrap;\n}\n\n.hero-feature {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #fff;\n}\n\n.hero-feature .feature-icon {\n  font-size: 2.5rem;\n  color: #32aa27;\n}\n\n.feature-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.feature-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #fff;\n}\n\n.feature-subtitle {\n  font-size: 0.875rem;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* ============================================\n   RESPONSIVE STYLES FOR NEW HERO\n   ============================================ */\n\n@media only screen and (max-width: 1200px) {\n  .hero-headline,\n  .hero-subheadline {\n    font-size: 3rem;\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .new-hero-section {\n    min-height: auto;\n    padding-top: 80px;\n  }\n\n  .new-hero-overlay {\n    position: relative;\n    background: linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 0.7) 0%,\n      rgba(0, 0, 0, 0.5) 50%,\n      rgba(0, 0, 0, 0.3) 100%\n    );\n  }\n\n  .new-hero-content {\n    padding-top: 40px;\n  }\n\n  .hero-headline,\n  .hero-subheadline {\n    font-size: 2.5rem;\n  }\n\n  .hero-description {\n    font-size: 1.1rem;\n    max-width: 100%;\n  }\n\n  .hero-features {\n    gap: 32px;\n    justify-content: flex-start;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .new-hero-section {\n    background-position: center;\n    min-height: auto;\n    padding-bottom: 20px;\n  }\n\n  .new-hero-overlay {\n    position: relative;\n    padding: 40px 0;\n  }\n\n  .new-hero-content {\n    text-align: center;\n    padding: 20px 0;\n    padding-top: 30px;\n  }\n\n  .hero-badge {\n    font-size: 0.7rem;\n    padding: 8px 14px;\n    margin-bottom: 20px;\n  }\n\n  .hero-headline,\n  .hero-subheadline {\n    font-size: 1.8rem;\n  }\n\n  .hero-description {\n    font-size: 1rem;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 100%;\n  }\n\n  .hero-buttons {\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .btn-find-berth,\n  .btn-list-berth {\n    width: 100% !important;\n    max-width: 300px !important;\n    justify-content: center !important;\n    padding: 12px 24px !important;\n    font-size: 0.9rem !important;\n  }\n\n  .btn-list-berth .circled-icon {\n    width: 20px;\n    height: 20px;\n  }\n\n  .btn-list-berth .circled-icon svg {\n    font-size: 14px;\n  }\n\n  .hero-features {\n    justify-content: center;\n    gap: 20px;\n    margin-top: 30px;\n    padding: 0 10px;\n  }\n\n  .hero-feature {\n    flex-direction: column;\n    text-align: center;\n    min-width: 90px;\n    flex: 1;\n  }\n\n  .feature-text {\n    align-items: center;\n  }\n\n  .hero-feature .feature-icon {\n    font-size: 1.8rem;\n  }\n\n  .feature-title {\n    font-size: 0.8rem;\n  }\n\n  .feature-subtitle {\n    font-size: 0.75rem;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .new-hero-section {\n    padding-top: 70px;\n  }\n\n  .new-hero-content {\n    padding-top: 20px;\n  }\n\n  .hero-headline,\n  .hero-subheadline {\n    font-size: 1.5rem;\n  }\n\n  .hero-badge {\n    font-size: 0.6rem;\n    padding: 6px 10px;\n    gap: 5px;\n  }\n\n  .hero-badge .badge-icon {\n    font-size: 0.75rem;\n  }\n\n  .hero-description {\n    font-size: 0.9rem;\n    margin-bottom: 24px;\n  }\n\n  .btn-find-berth,\n  .btn-list-berth {\n    padding: 10px 20px !important;\n    font-size: 0.85rem !important;\n  }\n\n  .hero-features {\n    gap: 12px;\n    margin-top: 24px;\n  }\n\n  .hero-feature {\n    min-width: 70px;\n  }\n\n  .hero-feature .feature-icon {\n    font-size: 1.5rem;\n  }\n\n  .feature-title {\n    font-size: 0.7rem;\n  }\n\n  .feature-subtitle {\n    font-size: 0.65rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
